/** Loading placeholder matching CourseCard's proportions. */
export default function CourseCardSkeleton() {
  return (
    <div className="rounded-2xl overflow-hidden animate-pulse border border-brand-borderLight/70 bg-white">
      <div className="h-52 bg-gray-100" />
      <div className="p-5 space-y-3">
        <div className="h-3 w-1/2 bg-gray-100 rounded" />
        <div className="h-4 w-3/4 bg-gray-100 rounded" />
        <div className="h-3 w-full bg-gray-100 rounded" />
        <div className="h-3 w-2/3 bg-gray-100 rounded" />
        <div className="h-10 w-full bg-gray-100 rounded-xl" />
      </div>
    </div>
  )
}
